import ApiRateLimitsList from './ApiRateLimitsList';
import ApiRateLimitsShow from './ApiRateLimitsShow';

const resource = {
  list: ApiRateLimitsList,
  show: ApiRateLimitsShow,
};

export default resource;
